import { TransferMechanism } from '../'
export enum DisbursementState {
  Requested = 'Requested',
  Validating = 'Validating',
  ValidationPassed = 'ValidationPassed',
  RejectedValidationFailed = 'RejectedValidationFailed',
  Analyzing = 'Analyzing',
  ReviewRequired = 'ReviewRequired',
  ReviewPending = 'ReviewPending',
  Approved = 'Approved',
  RejectedUnapproved = 'RejectedUnapproved',
  FundsPosting = 'FundsPosting',
  RejectedFundsNotPosted = 'RejectedFundsNotPosted',
  FundsStillPosted = 'FundsStillPosted',
  FundsPosted = 'FundsPosted',
  FailedAtBank = 'FailedAtBank',
  Prepared = 'Prepared',
  SendingToBank = 'SendingToBank',
  SentToBank = 'SentToBank',
  Batching = 'Batching',
  Batched = 'Batched',
  Reporting = 'Reporting',
  Completed = 'Completed',
  SendToBankFailed = 'SendToBankFailed',
  CompleteWaitingForReport = 'CompleteWaitingForReport',
  ErrorReporting = 'ErrorReporting',
  RejectedNotSentToBank = 'RejectedNotSentToBank',
  Returning = 'Returning',
  FundsReturned = 'FundsReturned',
  Returned = 'Returned',
  ReturnedWaitingForReversal = 'ReturnedWaitingForReversal',
  FundsCanceling = 'FundsCanceling',
  FundsCanceled = 'FundsCanceled',
  Canceled = 'Canceled',
  Postponing = 'Postponing',
  FundsPostponed = 'FundsPostponed',
  Postponed = 'Postponed',
  PostponedWaitingForReversal = 'PostponedWaitingForReversal'
}
export enum DisbursementType {
  PartialBalance = 'PARTIAL_BALANCE',
  FullBalance = 'FULL_BALANCE'
}
export interface DisbursementSummary {
  transferId: string
  mechanism: TransferMechanism
  state: DisbursementState
  requestedAmount: number
  feeAmount: number
  totalCustomerDebitAmount: number
  disbursementType: DisbursementType
  transferTime: string
  fundsPostedDate: string
}
export interface RecentDeposit {
  account: string
  amount: number
  mechanism: TransferMechanism
  description: string
  processDate: string
}
export interface AmountAvailableResponsePayload {
  account: string
  total: number
  unAdjustedTotal: number
  startDayCashAvailable: number
  pendingDebitInterest: number
  pendingDebitDividends: number
  fullyPaidUnsettledFunds: number
  includesFullyPaidUnsettledFunds: boolean
  totalDeposits: number
  totalDisbursements: number
  disbursements: DisbursementSummary[]
  recentDeposits: RecentDeposit[]
  recentDepositsThreshold: number
}
